import PropTypes from 'prop-types';
import React from 'react';
import CardGrid, { FooterText, formatCount } from './common/grid/CardGrid';
import FitGrid from './common/grid/FitGrid';
import CardRow from './common/grid/CardRow';
import CardGridBody from './common/grid/CardGridBody';
import ListInfoCard from './ListInfoCard';
import useGridLayout from '../hooks/useGridLayout';

export default function ListInfoCardGrid(props) {
  const {
    currentPage,
    listInfoActions,
    listActions,
  } = props;

  const { handleNextPage, handlePreviousPage } = listActions;

  const {
    pagesCount, pageNumber, lists, listCount,
  } = currentPage || {};

  const countLabel = formatCount(listCount, 'list', 'lists');

  const { arrangement, rowCap } = useGridLayout();
  const lgSpan = Math.max(1, Math.round(12 / arrangement.cols));
  const cardDirection = arrangement.cols === 1 ? 'column' : 'row';

  const items = lists || [];

  const card = (listInfo) => (
    <ListInfoCard listInfo={listInfo} {...listInfoActions} />
  );

  return (
    <CardGrid
      hasContent={items.length > 0}
      pageNumber={pageNumber}
      pagesCount={pagesCount}
      onNextPage={handleNextPage}
      onPreviousPage={handlePreviousPage}
      counter={countLabel ? <FooterText>{countLabel}</FooterText> : null}
    >
      <FitGrid>
        {items.length <= 3 ? (
          <CardRow items={items} direction={cardDirection} renderCard={card} />
        ) : (
          <CardGridBody items={items} renderCard={card} lgSpan={lgSpan} rowCap={rowCap} />
        )}
      </FitGrid>
    </CardGrid>
  );
}

ListInfoCardGrid.propTypes = {
  currentPage: PropTypes.object.isRequired,
  listInfoActions: PropTypes.object.isRequired,
  listActions: PropTypes.object.isRequired,
};
